<template>
  <fts-dropdown-select ref="dropdown" class="default-action-dropdown" content-class="default-action-dropdown-menu"
    :offset="[0, 6]" @show="openDropdown">
    <template #toggle>
      <slot name="toggle" />
    </template>

    <template #menu>
      <div class="fts-form-control-filter">
        <input type="text" class="fts-form-control" v-model="search" placeholder="Search" ref="searchInput" />
        <div class="search-icon">
          <fts-spinner :size="14" v-if="searching" />
          <font-awesome-icon :icon="['fas', 'search']" fixed-width v-else />
        </div>
      </div>


      <div v-if="standardActions.length > 0" class="dropdown-label">Standard Activities</div>
      <div v-if="standardActions.length > 0" class="dropdown-list">
        <div v-for="(x, rowIndex) in standardActions" :key="rowIndex" class="dropdown-option" :class="[
          { 'dropdown-option--active': action == x.id }
        ]" @click="toggleSelect(x)">
          <div class="dropdown-option-icon" v-if="x['fa-icon']">
            <font-awesome-icon :icon="['fas', x['fa-icon']]" fixed-width />
          </div>
          <div>{{ x.name }}</div>
        </div>
      </div>



      <div v-if="otherActions.length > 0" class="dropdown-label">Activities</div>
      <div v-if="otherActions.length > 0" class="dropdown-list">
        <div v-for="(x, rowIndex) in otherActions" :key="rowIndex" class="dropdown-option" :class="[
          { 'dropdown-option--active': action == x.id }
        ]" @click="toggleSelect(x)">
          <div class="dropdown-option-icon" v-if="x['fa-icon']">
            <font-awesome-icon :icon="['fas', x['fa-icon']]" fixed-width />
          </div>
          <div>{{ x.name }}</div>
        </div>
      </div>


      <div class="dropdown-no-results" v-if="!otherActions.length && !standardActions.length">
        No results found
      </div>

      <div class="button-wrapper">
        <button type="button" class="fts-btn fts-btn-raised fts-btn-primary" @click="confirmSelection">
          <font-awesome-icon :icon="['fas', 'check']" fixed-width />Save
        </button>
      </div>

    </template>
  </fts-dropdown-select>
</template>


<script>

import FTSPopper from './FTSPopperNew';
import FTSEmoji from '../elements/FTSEmoji';
import FTSToggleSwitch from '../elements/FTSToggleSwitch';
import FTSDropdownSelect from "../elements/FTSDropdownSelect";
import FTSLabelGroup from '../elements/FTSLabelGroup';

export default {
  name: 'DefaultActionDropdown',
  components: {
    'fts-popper': FTSPopper,
    'fts-emoji': FTSEmoji,
    'fts-toggle-switch': FTSToggleSwitch,
    "fts-dropdown-select": FTSDropdownSelect,
    'fts-label-group': FTSLabelGroup,
  },
  props: {
    defaultActivities: Array,
    activities: Array,
    initialSelected: String,
  },
  emits: ['select'],
  data() {
    return {
      search: '',
      searching: false,
      action: null,
    }
  },
  computed: {
    standardActions() {
      const query = this.search.toLowerCase();
      return this.defaultActivities
        .filter(item => item.name.toLowerCase().includes(query));
    },
    otherActions() {
      const query = this.search.toLowerCase();
      return this.activities.map((x) => ({ 'id': x.id, 'name': x.name })).filter(item => !['view', 'edit'].includes(item.id))
        .filter(item => item.name.toLowerCase().includes(query));
    }
  },
  methods: {
    openDropdown() {
      this.search = '';
      this.searching = false;
      this.action = this.initialSelected;
    },
    toggleSelect(item) {
      this.action = item['id'];
    },
    confirmSelection() {
      this.$emit('select', this.action);
      this.$refs.dropdown.$refs.popper.doClose();
    },
  },
};
</script>

<style lang="scss">
.default-action-dropdown-menu {
  min-height: 50px;
  padding: 0.5rem;
  background: #fff;
  border: 1px solid #ddd;
  text-align: center;
  color: #aaa;
}

.dropdown-label {
  text-align: left;
  padding: 4px 12px;
}
</style>
